<template>
    <div>
        <div class="unread-tip" v-if="message.id === -1">
            以下為未讀訊息({{ message.count }})
        </div>
        <div class="chat-message" :class="chatClass" v-else>
            <div class="name" :class="{'not-send': message.isNotSend}">{{ message.is_self ? '我本人' : '騎士' }}</div>
            <div class="content" :class="{'not-send': message.isNotSend}" v-show="message.content">{{ message.content }}</div>
            <chat-photo v-for="photo in message.photos" :photo="photo" :chat-id="chatId" :key="photo.id"/>
            <div class="error" v-show="message.isNotSend" @click="reSend">
                <div class="msg">傳送失敗，重試</div>
                <img src="@/assets/img/mes-refresh.svg">
            </div>
            <div class="bottom" v-show="!message.isNotSend">
                <div class="read" v-show="message.read_at != null">已讀</div>
                <div class="time">{{ message.created_at | time }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import ChatPhoto from "./ChatPhoto";
    import {pushOrderMessage} from "../../../apis";

    export default {
        name: "chatMessage",
        components: {
            'chat-photo': ChatPhoto,
        },
        props: {
            chatId: {
               require: true,
            },
            message: {
                require: true,
                type: Object
            }
        },
        computed: {
            chatClass() {
                return {
                    'chat-left': !this.message.is_self,
                    'chat-right': this.message.is_self,
                }
            }
        },
        methods: {
            reSend() {
                let payload = {
                    id: this.message.messageable_id,
                }

                if (this.message.type === 'text') {
                    payload.data = {
                        type: this.message.type,
                        content: this.message.content,
                    };
                } else {
                    let formData = new FormData();
                    formData.append('photo', this.message.photos[0].file, this.message.photos[0].file.name);
                    formData.append('type', 'photo');
                    payload.data = formData;
                }

                pushOrderMessage(payload).then(res => {
                    this.$emit('reSendMessage', {
                        notSendId: this.message.notSendId,
                        message: res.data,
                    });
                }).catch(error => {
                    this.$emit('reSendMessage', {
                        notSendId: this.message.notSendId,
                        message: {
                            id: 0,
                            user_id: this.message.user_id,
                            type: this.message.type,
                            messageable_type: this.message.messageable_type,
                            messageable_id: this.message.messageable_id,
                            content: this.message.content,
                            read_at: null,
                            photos: this.message.photos,
                            is_self: true,
                            created_at: moment().toISOString(),
                            isNotSend: true,
                            notSendId: (Math.random() * 1000000) + 1
                        }
                    });
                });
            }
        },
        filters: {
            time(date) {
                date = moment(date);
                let today = moment().format('MM/DD');

                if (today === date.format('MM/DD')) {
                    return date.format('hh:mm');
                }

                return moment(date).format('MM/DD hh:mm');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .unread-tip {
        background-color: #9B9B9B;
        margin: 10px 15px;
        border-radius: 9px;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0;
        text-align: center;
    }

    .chat-message {
        padding: 10px 15px;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 20px;
        color: #4A4A4A;
        display: flex;
        flex-direction: column;
        text-align: left;

        .error {
            display: flex;
            justify-content: center;
            align-items: baseline;
            user-select: none;
            cursor: pointer;

            .msg {
                margin-right: 5px;
            }
        }

        .bottom {
            display: flex;
            color: #9B9B9B;
            user-select: none;

            .read {
                margin-right: 5px;
            }
        }

        .name {
            user-select: none;
            &.not-send {
                color: #CCCCCC;
            }
        }

        .content {
            padding: 8px 15px;
            border: 1px solid #CCCCCC;
            background-color: #FAFAFA;
            box-sizing: border-box;
            width: fit-content;
            margin: 5px 0;
            max-width: 90%;
            word-break: break-word;
            white-space: pre-wrap;

            &.not-send {
                color: #CCCCCC;
            }
        }

        &.chat-left {
            align-items: flex-start;

            .content {
                border-radius: 15px 15px 15px 0;
            }
        }

        &.chat-right {
            align-items: flex-end;

            .content {
                border-radius: 15px 15px 0 15px;
            }
        }
    }
</style>